var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"workflow-page-enable"}},[_c('v-row',[_c('v-col',{staticClass:"text size-large weight-bold font-alt",attrs:{"cols":"12"}},[_vm._v("\n      Mettez à jour vos informations\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }